import LinkDropdown from './LinkDropdown';

document
  .querySelectorAll('.link-dropdown')
  .forEach(($el) => new LinkDropdown($el));
